import React from "react";
import { View } from "react-native";

import { formatValue } from "arkh/common";
import {
  AHNumberInput,
  AHNumberInputRef,
  AHText,
  AHTextFonts,
  Box,
  BoxProps,
  TouchableBox,
  useLayoutContext,
  useTheme,
  AHIcon,
} from "arkh";
import { Goal } from "../../features/RoutineAdmin/State/Routine/types";

export function NumberGoalValueIcon({
  goal,
  value,
  unit,
  color,
  ...boxProps
}: { goal: Goal; value: number; unit: "CURRENCY" | "CUSTOM" } & BoxProps) {
  const theme = useTheme();
  const layout = useLayoutContext();

  const [format, u] = formatValue(unit, value);
  return (
    <Box
      style={{
        minWidth: 40,
      }}
      {...boxProps}
    >
      <Box>
        <Box
          style={{
            position: "absolute",
            bottom: layout.space.xxsmall,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ margin: 0, marginBottom: -4, marginTop: -4 }}>
            <AHIcon
              type="chevron-up"
              customColor={goal === "min" ? theme.positive : theme.negative}
              forceSize={14}
            />
          </View>
        </Box>
      </Box>
      <AHText
        type="body"
        style={{ textAlign: "center" }}
        font={AHTextFonts.BOLDER}
        color={color}
      >
        {format(value)} {u}
      </AHText>
      <Box>
        <Box
          style={{
            position: "absolute",
            top: layout.space.xxsmall,
            width: "100%",
            height: 4,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ marginBottom: -4, marginTop: -4 }}>
            <AHIcon
              type="chevron-down"
              forceSize={14}
              customColor={goal === "max" ? theme.positive : theme.negative}
            />
          </View>
        </Box>
      </Box>
    </Box>
  );
}

export const NumberGoalValueInput = (props: {
  goal: Goal;
  value: number;
  onFocus?: () => void;
  onBlur?: () => void;
  setValue: (value: number) => void;
  size?: "small" | "medium";
  ref?: React.RefObject<AHNumberInputRef | null>;
}) => {
  const theme = useTheme();
  return (
    <TouchableBox
      style={{ alignItems: "center", maxWidth: 160 }}
      onPress={() => {}}
    >
      <Box spaceBottom="xsmall">
        <View style={{ marginTop: -6, marginBottom: -7 }}>
          <AHIcon
            type="chevron-up"
            customColor={props.goal === "min" ? theme.positive : theme.negative}
            forceSize={props.size === "medium" ? 20 : 14}
          />
        </View>
      </Box>
      <AHNumberInput
        ref={props.ref}
        clearTextOnFocus
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        value={props.value}
        setValue={props.setValue}
        disabled={false}
        buttonsShow={false}
        minValue={0}
        maxValue={1000000000}
        spaceVertical="none"
        textInputStyle={{
          width: undefined,
          fontFamily: AHTextFonts.BOLD,
          fontSize: 14,
        }}
        inputContainerStyle={
          props.size === "small"
            ? {
                minHeight: 30,
              }
            : null
        }
      />
      <Box spaceTop="xsmall">
        <View style={{ marginTop: -7, marginBottom: -6 }}>
          <AHIcon
            type="chevron-down"
            customColor={props.goal === "max" ? theme.positive : theme.negative}
            forceSize={props.size === "medium" ? 20 : 14}
          />
        </View>
      </Box>
    </TouchableBox>
  );
};
